mutation (
  $email: AWSEmail!
  $locale: Locale!
) {
  forgotPassword(
    email: $email
    locale: $locale
  )
}
